import * as Sentry from '@sentry/browser'
import { captureMonitorException, initMonitorClient, MONITOR_EVENT, MONITOR_PATH, MONITOR_SOURCE, getMonitorTags } from '@/utils/monitor'

const DEFAULT_TRACES_SAMPLE_RATE = 0.01

// 统一去掉 .env 字符串两侧可能带上的引号，避免配置值解析异常。
const trimQuote = value => value?.trim()?.replace(/^['"]|['"]$/g, '')

// 采样率要求是 0 到 1 之间的数字，非法时回退到默认值。
const getTracesSampleRate = () => {
  const sampleRate = Number(trimQuote(import.meta.env.VITE_APP_GLITCHTIP_TRACES_SAMPLE_RATE))

  if (Number.isFinite(sampleRate) && sampleRate >= 0 && sampleRate <= 1) {
    return sampleRate
  }

  return DEFAULT_TRACES_SAMPLE_RATE
}

export const setupGlitchTip = app => {
  const dsn = trimQuote(import.meta.env.VITE_APP_GLITCHTIP_DSN)

  if (!dsn) return

  // 这里只负责初始化 monitor core，不再在这里直接编排 Sentry 细节。
  initMonitorClient({
    dsn,
    environment: import.meta.env.MODE,
    release: trimQuote(import.meta.env.VITE_APP_VERSION_TIME),
    tracesSampleRate: getTracesSampleRate(),
    autoSessionTracking: false,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
  })

  const previousErrorHandler = app.config.errorHandler

  // Vue 全局运行时异常统一交给 monitor core，
  // 并补充组件名和 info 作为结构化上下文。
  app.config.errorHandler = (error, instance, info) => {
    captureMonitorException(error, {
      tags: getMonitorTags({
        monitorSource: MONITOR_SOURCE.RUNTIME,
        monitorEvent: MONITOR_EVENT.VUE_ERROR,
        monitorPath: MONITOR_PATH.GLITCHTIP,
      }),
      contexts: {
        vue: {
          info,
          component: instance?.type?.name || instance?.type?.__name || 'anonymous',
        },
      },
    })

    if (typeof previousErrorHandler === 'function') {
      previousErrorHandler(error, instance, info)
    }
  }
}
